import {Component, OnInit} from '@angular/core';
import {MarriageService} from '../../../services/marriage.service';

@Component({
  selector: 'vb-marriage-summary-page',
  templateUrl: './marriage-summary-page.component.html',
  styleUrls: ['./marriage-summary-page.component.css']
})
export class MarriageSummaryPageComponent implements OnInit {

  objectKeys = Object.keys;

  constructor(public marriageService: MarriageService) {

  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/asset-management/components/asset-marriage-wizard/marriage-summary-page/marriage-summary-page.component.ts